import { Route } from 'react-router-dom';
import TeamPage from './pages/TeamPage';

export const TeamRoutes = [
  <Route key="team" path="/dashboard/team" element={<TeamPage />} />
];
